import { render, staticRenderFns } from "./BalanceStatisticItem.vue?vue&type=template&id=31fdd990&scoped=true"
import script from "./BalanceStatisticItem.vue?vue&type=script&lang=js"
export * from "./BalanceStatisticItem.vue?vue&type=script&lang=js"
import style0 from "./BalanceStatisticItem.vue?vue&type=style&index=0&id=31fdd990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fdd990",
  null
  
)

export default component.exports